import { render, staticRenderFns } from "./privacy-policy.vue?vue&type=template&id=4568d7fc&scoped=true&"
var script = {}
import style0 from "./privacy-policy.vue?vue&type=style&index=0&id=4568d7fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4568d7fc",
  null
  
)

export default component.exports